<!-- =========================================================================================
  File Name: ItemGridView.vue
  Description: Item Component - Grid VIew

========================================================================================== -->

<template>
  <!-- <div class="item-grid-view vx-row match-height">
      <div class="vx-col" :class="gridColumnWidth" v-for="item in items" :key="item.objectID"> -->
  <vx-card class="grid-view-item mb-base overflow-hidden w-full no-padding" v-on="$listeners">
    <template slot="no-body">

      <div class="simulation-icon-top-right">
        <feather-icon v-if="progress === 100" icon="CheckCircleIcon" svgClasses="h-8 w-8 self-center bg-success rounded-full p-1 text-white"/>
        <feather-icon v-else icon="XCircleIcon" svgClasses="h-8 w-8 self-center bg-danger rounded-full p-1 text-white"/>
      </div>

      <vs-progress :percent="progress" class="block shadow-md bg-danger" color="success"
                   v-if="progress !== 0"></vs-progress>
      <vs-progress :percent="100" class="block shadow-md" color="danger" v-else></vs-progress>

      <div class="item-img-container flex items-center justify-center cursor-pointer"
           @click="navigate_to_detail_view">
        <img
          :src="item.thumbnail ? item.thumbnail : 'https://cdn.discordapp.com/attachments/746242308084858900/848762736255172679/default-placeholder.png'"
          :alt="item.name" class="grid-view-img" style="width: 100%; height: 300px; object-fit: cover;">
        <div class="simulation-card-overlay flex flex-col justify-between">
          <!--- <div>
            <h1 class="text-white mb-4 font-semibold pr-8">{{ item.name }}</h1>
            <p>{{ item.description }}</p>
          </div> --->

           <div class="flex">
             <!--- <div class="flex">
                <div class="text-white border border-solid border-white flex py-1 px-2 rounded mr-1">
                  <feather-icon icon="BookIcon" svgClasses="h-4 w-4 mr-1 self-center"/>
                  <span class="text-sm self-center">{{ activeCourseInfo.name }}</span>
                </div>
               <div class="text-white border border-solid border-white flex py-1 px-2 rounded ml-1">
                  <feather-icon icon="CodesandboxIcon" svgClasses="h-4 w-4 mr-1 self-center"/>
                  <span class="text-sm self-center">{{
                      difficulties.find((x) => parseInt(x.id) === parseInt(item.difficulty)).name
                    }}</span>
                </div>
              </div>--->
            <img src="https://cdn.discordapp.com/attachments/746242308084858900/826260477029122078/SiteICON.png" class="w-8 self-center">
          </div>

        </div>
      </div>

      <!--- <div class="item-details px-4">

      </div> --->

      <slot name="action-buttons"/>
    </template>
  </vx-card>
  <!--  </div>
</div> -->
</template>

<script>
export default{
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      difficulties: [
        {id: '0', name: 'Simple'},
        {id: '1', name: 'Easy'},
        {id: '2', name: 'Moderate'},
        {id: '3', name: 'Hard'},
        {id: '4', name: 'Challenging'}
      ],
      progress: 0
    }
  },
  methods: {
    navigate_to_detail_view () {
      this.$router.push({name: 'legacy-simulation-starter', params: {simulationId: this.item.id }})
        .catch(() => {})
    }
  },
  created () {
    this.$http.get(`progress/user/specific/@me/simulation/progress?simulation=${this.item.id}`)
      .then(response => {
        this.progress = parseInt(response.data.data)
      })
  },
  computed: {
    activeCourseInfo () {
      return this.$store.state.AppActiveCourse
    }
  }
}
</script>

<style lang="scss" scoped>

.grid-view-item {

  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -moz-user-select: none; /* Old versions of Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none;

  .grid-view-img {
    max-width: 100%;
    max-height: 100%;
    width: auto;
    transition: .35s;
  }

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0px 4px 25px 0px rgba(0, 0, 0, .25);

    .grid-view-img {
      opacity: 0.9;
    }
  }

  .vs-progress--background {
    z-index: 0!important;
  }

  .simulation-card-overlay {
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    padding: 1.25rem;
  }

  .simulation-icon-top-right {
    position: absolute;
    top: 15px;
    right: 10px;
    z-index: 1;
  }

}
</style>
